<template>
  <Modal
    class="scoped"
    :modal-style="{ width: '750px' }"
    :title="title"
  >
    <div v-if="shiftSpec">
      <div class="item no-padding">
        <SelectList
          v-model="userId"
          class="q-ma-xs"
          dense
          :disabled="shiftSpec.isPersisted"
          label="User"
          option-label="name"
          option-value="id"
          :options="users"
          :rules="[(val) => val > 0 || 'Must select a User']"
          @update:model-value="setUser"
        />
        <SelectList
          v-model="shiftSpec.startTime"
          class="q-ma-xs"
          dense
          label="Time"
          option-label="label"
          option-value="value"
          :options="timeSlots"
          :rules="[(val) => val > 0 || 'Must select a Role']"
        />
      </div>
    </div>

    <template #buttons>
      <QBtn
        class="q-mr-md text-black"
        color="default"
        label="Cancel"
        @click="close"
      />
      <QBtn
        class="no-shadow bg-primary bold q-my-smd text-white"
        label="Save"
        @click="save"
      />
    </template>
  </Modal>
</template>

<script>
import fromUnixTime from "date-fns/fromUnixTime";

import Modal from "shared/components/core/modals/Modal.vue";
import { addTime, dateToTimestamp, formatDate } from "shared/helpers/date";
import UserShiftSpec from "shared/resources/UserShiftSpec";

import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "RosterAllocateUserModal",
  components: {
    Modal,
    SelectList,
  },
  props: {
    specification: {
      type: Object,
      required: true,
    },
    role: {
      type: Object,
      required: true,
    },
    shiftSpec: {
      type: Object,
      default: null,
    },
    shifts: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["close", "confirm"],
  data() {
    return {
      userId: null,
    };
  },
  computed: {
    timeSlots() {
      if (!this.selectedShift) return [];

      const slots = [];
      let time = fromUnixTime(this.selectedShift.startTime);
      const end = fromUnixTime(this.selectedShift.endTime);

      while (time <= end) {
        slots.push({
          value: dateToTimestamp(time),
          label: formatDate(time, "haaa"),
        });

        time = addTime(time, 1, "hour");
      }

      return slots;
    },
    selectedShift() {
      if (!this.shiftSpec) return null;

      return this.shifts.find(
        (shift) =>
          shift.user.id === this.userId ||
          shift.id === this.shiftSpec.userShiftId
      );
    },
    users() {
      return this.shifts.map((shift) => shift.user);
    },
    title() {
      return `Allocate ${this.role.label} user for: ${this.specification.title}`;
    },
  },
  mounted() {
    if (this.shiftSpec) {
      this.userId = this.selectedShift.user.id;
    } else {
      this.shiftSpec = new UserShiftSpec({
        specificationId: this.specification.id,
        role: this.role.value,
      });
    }
  },
  methods: {
    setUser(user) {
      this.selectedShift.userId = user.id;
    },
    close() {
      this.$emit("close");
    },
    save() {
      if (!this.shiftSpec.isPersisted) {
        this.selectedShift.specifications.push(this.shiftSpec);
      }

      this.$emit("confirm", this.selectedShift);
      this.close();
    },
  },
};
</script>
